import { CandidateBatchStatus } from 'generated-graphql/types';

export const getAnalyseDetailsStatusText = (status?: CandidateBatchStatus) => {
  switch (status) {
    case CandidateBatchStatus.PreProcessing:
    case CandidateBatchStatus.ReadyToProcess:
    case CandidateBatchStatus.Created:
      return 'Preparing analysis';
    case CandidateBatchStatus.RankingCandidates:
      return 'Analysing candidates.';
    default:
      return 'Preparing analysis';
  }
};
